import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import { getStadiumImageUrl } from '../constants/config';
import {
  NEWS_ENTITY_TYPES,
  normalizeSearchItem,
  searchTypeLabelKey,
} from '../utilities/adminSearch';
import { useI18n } from '../utilities/i18n';
import { newsEntityKey, parseNewsEntities } from '../utilities/newsApi';
import AdminSearchPicker from './AdminSearchPicker';

export default function NewsEntityPicker({
  value = [],
  onChange,
  disabled,
}) {
  const { t } = useI18n();
  const selected = parseNewsEntities(value);
  const selectedKeys = selected.map(newsEntityKey);
  const [activeType, setActiveType] = useState('all');

  const addEntity = (item) => {
    const parsed = normalizeSearchItem(item, item?.type || (activeType !== 'all' ? activeType : ''));
    const key = newsEntityKey(parsed);
    if (!parsed || !key || selectedKeys.includes(key)) return;
    onChange(selected.concat(parsed));
  };

  const removeEntity = (key) => {
    onChange(selected.filter((item) => newsEntityKey(item) !== key));
  };

  return (
    <div className={`news-entity-picker ${disabled ? 'is-disabled' : ''}`}>
      <div className="news-filter-add">
        <select
          className="st-select news-filter-type"
          value={activeType}
          disabled={disabled}
          onChange={(event) => setActiveType(event.target.value)}
        >
          <option value="all">{t('searchTypeAll')}</option>
          {NEWS_ENTITY_TYPES.map((item) => (
            <option key={item.type} value={item.type}>{t(item.labelKey)}</option>
          ))}
        </select>
        <AdminSearchPicker
          type={activeType}
          disabled={disabled}
          placeholder={t('newsEntitiesPh')}
          excludeKeys={selectedKeys}
          onPick={addEntity}
        />
      </div>

      {selected.length ? (
        <div className="news-tag-chips">
          {selected.map((item) => {
            const key = newsEntityKey(item);
            const typeKey = searchTypeLabelKey(item.type);
            const typeLabel = typeKey ? t(typeKey) : item.type;
            const image = item.type !== 'city' ? getStadiumImageUrl(item.image) : '';
            return (
              <span key={key} className="usr-chip news-tag-chip news-entity-chip">
                {image ? <img className="news-entity-chip-image" src={image} alt="" /> : null}
                <span className="news-tag-chip-text">
                  <span>{item.name || `#${item.id}`}</span>
                  <small>{item.subtitle ? `${typeLabel} · ${item.subtitle}` : typeLabel}</small>
                </span>
                {!disabled ? (
                  <button
                    type="button"
                    className="news-tag-remove"
                    onClick={() => removeEntity(key)}
                    aria-label={t('newsEntityRemove', { name: item.name || `#${item.id}` })}
                  >
                    <FiX />
                  </button>
                ) : null}
              </span>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
